/**
 * Meta Pixel event tracking helpers.
 *
 * The base pixel (PageView) is loaded via index.html.
 * These helpers fire standard events that Meta Ads Manager
 * can optimise against.
 */

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

function track(event: string, params?: Record<string, unknown>) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', event, params);
  }
}

export function trackAddToCart(name: string, quantity: number, value: number, currency = 'NOK') {
  track('AddToCart', {
    content_name: name,
    content_type: 'product',
    value,
    currency,
    num_items: quantity,
  });
}

export function trackInitiateCheckout(numItems: number, value: number, currency = 'NOK') {
  track('InitiateCheckout', {
    content_type: 'product',
    num_items: numItems,
    value,
    currency,
  });
}

export function trackPurchase(value: number, currency = 'NOK') {
  track('Purchase', {
    content_type: 'product',
    value,
    currency,
  });
}

export function trackCompleteRegistration() {
  track('CompleteRegistration');
}

export function trackSearch(searchString: string) {
  track('Search', { search_string: searchString });
}
